var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    { staticClass: "dropdown-item notification-item", attrs: { href: "#" } },
    [
      _c("div", { staticClass: "media h-25 table-responsive" }, [
        _c("div", { staticClass: "media-body p-1" }, [
          _c("h6", { staticClass: "dropdown-item-title" }),
          _c(
            "div",
            { staticClass: "text-sm" },
            [
              _vm.isAbsenceConfirmWaiting
                ? _c("absence-confirm-waiting-day-legend", {
                    attrs: {
                      title: _vm.notificationData.causeOfAbsenceDescription,
                    },
                  })
                : _vm._e(),
              _vm.isVacationsConfirmWaiting
                ? _c("vacation-confirm-waiting-day-legend", {
                    attrs: {
                      title: _vm.notificationData.causeOfAbsenceDescription,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _c("div", { staticClass: "text-sm p-1" }, [
            _c("i", { staticClass: "fas fa-user notification-icon" }),
            _c("span", { staticClass: "text-bold pl-2" }, [
              _vm._v(_vm._s(_vm.employeeName)),
            ]),
          ]),
          _c("div", { staticClass: "text-sm p-1" }, [
            _c("i", { staticClass: "far fa-clock notification-icon" }),
            _c(
              "span",
              { staticClass: "pl-2" },
              [
                _c("formatted-date-component", {
                  attrs: { val: _vm.dateStart, withTime: true },
                }),
                _vm._v(" - "),
                _c("formatted-date-component", {
                  attrs: { val: _vm.dateEnd, withTime: true },
                }),
              ],
              1
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }